function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connectTwoFactorAuthentication } from '@/actions/AuthActions';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import useHydrated from '@/hooks/useHydrated';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
import { Button, FocusTrap, TextInput } from '@mantine/core';
import Notice from '../Notice';
export default function TwoFactor() {
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(''), 2), value = _React_useState[0], setValue = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), error = _React_useState1[0], setError = _React_useState1[1];
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            accessToken: state.accessToken,
            redirectPath: state.redirectPath,
            unverified2FA: state.unverified2FA,
            setRedirectPath: state.setRedirectPath,
            setAccessToken: state.setAccessToken,
            setUnverified2FA: state.setUnverified2FA
        };
    })), accessToken = _useAuthenticationStore.accessToken, redirectPath = _useAuthenticationStore.redirectPath, unverified2FA = _useAuthenticationStore.unverified2FA, setRedirectPath = _useAuthenticationStore.setRedirectPath, setAccessToken = _useAuthenticationStore.setAccessToken, setUnverified2FA = _useAuthenticationStore.setUnverified2FA;
    var isHydrated = useHydrated(useAuthenticationStore);
    var navigate = useNavigate();
    var redirectLogin = useLoginRedirect(redirectPath);
    React.useEffect(function() {
        if (!isHydrated) {
            return;
        }
        if (unverified2FA && accessToken != null) {
            return;
        }
        redirectLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isHydrated
    ]);
    var handleComplete = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var accessToken, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        connectTwoFactorAuthentication(value, false)
                    ];
                case 1:
                    accessToken = _state.sent().accessToken;
                    setAccessToken(accessToken);
                    setUnverified2FA(false);
                    setRedirectPath(null);
                    navigate(redirectPath !== null && redirectPath !== void 0 ? redirectPath : WebRoutes.DASHBOARD);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if (_instanceof(error, Error)) {
                        setError(error.message);
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        value,
        setAccessToken,
        setUnverified2FA,
        setRedirectPath,
        navigate,
        redirectPath
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "AJyYQz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Two-Factor Authentication"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Notice, {
                heading: intl.formatMessage({
                    id: "AJyYQz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Two-Factor Authentication"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "uzxsPt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the code generated by your Authenticator, or enter a stored back-up code."
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(FocusTrap, {
                    children: /*#__PURE__*/ _jsx(TextInput, {
                        variant: "outline",
                        autoComplete: "one-time-code",
                        value: value,
                        onChange: function(event) {
                            return setValue(event.currentTarget.value);
                        },
                        error: error,
                        placeholder: intl.formatMessage({
                            id: "h2vipu",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Code"
                                }
                            ]
                        })
                    })
                }),
                buttons: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "sm",
                        variant: "normal",
                        onClick: redirectLogin,
                        children: intl.formatMessage({
                            id: "47FYwb",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Cancel"
                                }
                            ]
                        })
                    }, "cancel"),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "sm",
                        variant: "inverse",
                        onClick: handleComplete,
                        children: intl.formatMessage({
                            id: "q5Xl0M",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Verify"
                                }
                            ]
                        })
                    }, "verify")
                ]
            })
        ]
    });
}
